import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanDeactivateWithPendingWork {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class MultiSearchPendingGuard implements CanDeactivate<CanDeactivateWithPendingWork> {
  canDeactivate(component: CanDeactivateWithPendingWork): Observable<boolean> | Promise<boolean> | boolean {
    if (!component || typeof component.canDeactivate !== 'function') {
      return true;
    }
    return component.canDeactivate();
  }
}
